import { useEffect, useState } from 'react';
import { createSession, getGuests } from './api';
import './App.css';
import EventPage from './components/EventPage';
import PasswordGate from './components/PasswordGate';
import { Guest } from './types';

function App() {
  const [unlocked, setUnlocked] = useState(false);
  const [guests, setGuests] = useState<Guest[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    getGuests(controller.signal)
      .then((loadedGuests) => {
        setGuests(loadedGuests);
        setUnlocked(true);
      })
      .catch(() => undefined);
    return () => controller.abort();
  }, []);

  const unlock = async (password: string) => {
    await createSession(password);
    const loadedGuests = await getGuests();
    setGuests(loadedGuests);
  };

  const relock = () => {
    setUnlocked(false);
    setGuests([]);
  };

  return unlocked ? (
    <EventPage
      guests={guests}
      onGuestAdded={(guest) => setGuests((current) => [...current, guest])}
      onUnauthorized={relock}
    />
  ) : (
    <PasswordGate
      onUnlock={unlock}
      onComplete={() => setUnlocked(true)}
    />
  );
}

export default App;
